import { useEffect, useState } from 'react';

const TABLET_MEDIA_QUERY = '(min-width: 768px) and (max-width: 1023px)';

const useIsTablet = () => {
  const getInitialValue = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia(TABLET_MEDIA_QUERY).matches;
  };

  const [isTablet, setIsTablet] = useState(getInitialValue);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(TABLET_MEDIA_QUERY);
    const handleChange = (event) => {
      setIsTablet(event.matches);
    };

    setIsTablet(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);

    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, []);

  return isTablet;
};

export default useIsTablet;
